import _axios from '../../apiClient'


export function getNuevosUsuarios(page) {

  return _axios.get(`/api/usuario/Nuevos`,
    {
      params: {page: page - 1},
      headers: { 'Content-Type': 'application/json;charset=UTF-8' }
    })
    .then(response => response.data)
    .catch((error) => {
      const data = error.response.data
      throw (data)
    })
}
export function getUsuarios(payload) {

  return _axios.get(`/api/usuario/Find`,
    {
      params: {...payload, page: payload.page - 1},
      headers: { 'Content-Type': 'application/json;charset=UTF-8' }
    })
    .then(response => response.data)
    .catch((error) => {
      const data = error.response.data
      throw (data)
    })
}

export function getUsuario(id) {

  return _axios.get(`/api/usuario/get`,
    {
      params: {id},
      headers: { 'Content-Type': 'application/json;charset=UTF-8' }
    })
    .then(response => response.data).catch((error) => { const data = error.response.data;throw (data)})
}


export function getLocalidades(nombre) {

  return _axios.get(`/api/usuario/Localidad`,
    {
      params: {nombre},
      headers: { 'Content-Type': 'application/json;charset=UTF-8' }
    })
    .then(response => response.data).catch((error) => { const data = error.response.data;throw (data)})
}

export function saveUsuario(usuario) {

  return _axios.post(`/api/usuario/save`,
  usuario  
  ,{
      headers: { 'Content-Type': 'application/json;charset=UTF-8' }
    })
    .then(response => response.data)
    .catch((error) => { const data = error.response.data; throw (data)})
}

export function HabilitarUsuario(payload) {
  return _axios.post(`/api/Usuario/Habilitar`,
  payload
  ,{
    headers: { 'Content-Type': 'application/json;charset=UTF-8' }
  })
  .then(response => response.data)
  .catch((error) => {
    const data = error.response.data
    throw (data)
  })
}
export function eliminarUsuario(payload) {
  return _axios.post(`/api/Usuario/Eliminar`,
  payload
  ,{
    headers: { 'Content-Type': 'application/json;charset=UTF-8' }
  })
  .then(response => response.data)
  .catch((error) => {
    const data = error.response.data
    throw (data)
  })
}
export function reactivarUsuario(payload) {
  return _axios.post(`/api/Usuario/Reactivar`,
  payload
  ,{
    headers: { 'Content-Type': 'application/json;charset=UTF-8' }
  })
  .then(response => response.data)
  .catch((error) => {
    const data = error.response.data
    throw (data)
  })
}

export function reestablecerUsuario(payload) {
  return _axios.post(`/api/Usuario/Reestablecer`,
  payload
  ,{
    headers: { 'Content-Type': 'application/json;charset=UTF-8' }
  })
  .then(response => response.data)
  .catch((error) => {
    const data = error.response.data
    throw (data)
  })
}

export function confirmarUsuario(payload) {
  return _axios.post(`/api/Usuario/Confirmar`,
  payload
  ,{
    headers: { 'Content-Type': 'application/json;charset=UTF-8' }
  })
  .then(response => response.data)
  .catch((error) => {
    const data = error.response.data
    throw (data)
  })
}

export function enviarConfirmacionUsuario(payload) {
  return _axios.post(`/api/Usuario/EnviarConfirmacion`,
  payload
  ,{
    headers: { 'Content-Type': 'application/json;charset=UTF-8' }
  })
  .then(response => response.data)
  .catch((error) => {
    const data = error.response.data
    throw (data)
  })
}


export function saveDireccionEntrega(payload) {
  return _axios.post(`/api/Usuario/SaveDireccionEntrega`,
    payload,
    {
      headers: {
        'Content-Type': 'application/json;charset=UTF-8',
      }
    })
    .then(response => response.data)
    .catch((error) => {
      const data = error.response.data
      throw data
    })
}

export function agregarListaBlanca(payload) {
  return _axios.post(`/api/Usuario/AddListaBlanca`,
  payload
  ,{
    headers: { 'Content-Type': 'application/json;charset=UTF-8' }
  })
  .then(response => response.data)
  .catch((error) => {
    const data = error.response.data
    throw (data)
  })
}

export function eliminarListaBlanca(payload) {
  return _axios.post(`/api/Usuario/RemoveListaBlanca`,
  payload
  ,{
    headers: { 'Content-Type': 'application/json;charset=UTF-8' }
  })
  .then(response => response.data)
  .catch((error) => {
    const data = error.response.data
    throw (data)
  })
}

export function agregarListaNegra(payload) {
  return _axios.post(`/api/Usuario/AddListaNegra`,
  payload
  ,{
    headers: { 'Content-Type': 'application/json;charset=UTF-8' }
  })
  .then(response => response.data)
  .catch((error) => {
    const data = error.response.data
    throw (data)
  })
}

export function eliminarListaNegra(payload) {
  return _axios.post(`/api/Usuario/RemoveListaNegra`,
  payload
  ,{
    headers: { 'Content-Type': 'application/json;charset=UTF-8' }
  })
  .then(response => response.data)
  .catch((error) => {
    const data = error.response.data
    throw (data)
  })
}

export function setSucursalesUsuario(payload) {
  return _axios.post(`/api/Usuario/SetSucursalUsuario/${payload.idUsuario}`,
  {idSucursalesActivas: payload.activas, idSucursalesDesactivas: payload.desactivas}
  ,{
    headers: { 'Content-Type': 'application/json;charset=UTF-8' }
  })
  .then(response => response.data)
  .catch((error) => {
    const data = error.response.data
    throw (data)
  })
}
